function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Caminho_1152",
  "data-name": "Caminho 1152"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 12 23 C 9.061790466308594 23 6.299449920654297 21.85580062866211 4.221819877624512 19.77817916870117 C 2.144200086593628 17.7005500793457 1 14.93820953369141 1 12 C 1 9.061790466308594 2.144200086593628 6.299449920654297 4.221819877624512 4.221819877624512 C 6.299449920654297 2.144200086593628 9.061790466308594 1 12 1 C 14.93820953369141 1 17.7005500793457 2.144200086593628 19.77817916870117 4.221819877624512 C 21.85580062866211 6.299449920654297 23 9.061790466308594 23 12 C 23 14.93820953369141 21.85580062866211 17.7005500793457 19.77817916870117 19.77817916870117 C 17.7005500793457 21.85580062866211 14.93820953369141 23 12 23 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 12 2 C 6.485979080200195 2 2 6.485979080200195 2 12 C 2 17.51401901245117 6.485979080200195 22 12 22 C 17.51401901245117 22 22 17.51401901245117 22 12 C 22 6.485979080200195 17.51401901245117 2 12 2 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z",
  stroke: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1151",
  "data-name": "Caminho 1151",
  d: "M2.377,15.714H.688V5.833H2.377ZM.551,3.212A1.008,1.008,0,0,1,.8,2.517a.943.943,0,0,1,.744-.283.958.958,0,0,1,.749.283,1,1,0,0,1,.256.694A.965.965,0,0,1,2.3,3.9a.975.975,0,0,1-.749.274A.96.96,0,0,1,.8,3.9.975.975,0,0,1,.551,3.212Z",
  transform: "translate(10.449 2.73)",
  fill: "#fff"
});

function SvgIFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1747",
    "data-name": "Grupo 1747",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFilled);
export default __webpack_public_path__ + "static/media/i-filled.47142cab.svg";
export { ForwardRef as ReactComponent };